import React, {forwardRef, useCallback} from 'react'
import PropTypes from 'prop-types'
import NavigationItem from '../navigation-item'

/**
 * Renders lvl1 items in the mobile and desktop drawer menu.
 */
const Lvl1Item = forwardRef(({item, isActive, onClick: _onClick}, ref) => {
    // handle lvl1 item click
    const onClick = useCallback(
        (e) => {
            e?.preventDefault()
            e?.stopPropagation()
            _onClick?.(item, e)
        },
        [item, _onClick]
    )

    return (
        <NavigationItem
            ref={ref}
            {...item}
            // as per specification images on lvl1 items should not be displayed
            image=""
            levelIdx={1}
            selected={isActive}
            onClick={onClick}
            trackingIndex={1}
            styles={{height: '3rem'}}
        />
    )
})

Lvl1Item.propTypes = {
    item: PropTypes.object.isRequired,
    isActive: PropTypes.bool,
    onClick: PropTypes.func,
    itemRef: PropTypes.object
}

if (process.env.NODE_ENV !== 'production') {
    Lvl1Item.displayName = 'Lvl1Item'
}

export default Lvl1Item
